
                  export default function (Component) {
                      Component.__source = "src/components/moduleTitle.vue"
                  }
              